import React from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

const StyledDateDivider = styled.div`
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 0;
  &::before {
    content: '';
    position: absolute;
    width: calc(50% - 7rem);
    height: 1px;
    background-color: ${colors.LIGHT_PERIWINKLE};
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
  }
  &::after {
    content: '';
    position: absolute;
    width: calc(50% - 7rem);
    height: 1px;
    background-color: ${colors.LIGHT_PERIWINKLE};
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const StyledDateDiverInner = styled.span`
  padding: 1rem;
  position: relative;
  z-index: 1;
  font-size: 0.7rem;
  color: ${colors.MEDIUM_GRAY};
  text-transform: uppercase;
`;

const StyledBoldText = styled.span`
  font-family: 'Circular-Bold';
`;

const TimestampDivider = ({ fromNow, time }) => {
  return (
    <StyledDateDivider>
      <StyledDateDiverInner>
        <StyledBoldText>{fromNow}</StyledBoldText>
      </StyledDateDiverInner>
    </StyledDateDivider>
  );
};

export default TimestampDivider;
